/**
 * L'onglet « Aide » du panneau de droite — les leçons de l'introduction, à
 * portée de main pendant la simulation.
 *
 * 🪦 C'était une colonne entière de trois pages (« Cyrano », « Les offres »,
 * « Le script », 19-08-2026), avec l'ultimatum en exemple et un bouton
 * Agrandir. La scène du 06-10 n'a plus d'ultimatum, et la colonne de droite est
 * redevenue celle du POSTE (Francis · Scripts) : la doc y prend un onglet, pas
 * la place.
 *
 * Le texte est `LECONS` (`lecons.ts`), la MÊME copie que l'écran
 * d'introduction : ce qu'il a lu avant de commencer est exactement ce qu'il
 * relit ici, au mot près.
 */
import { Carte } from "@/shared/ui";

import { Paragraphe } from "./IntroDuTest";
import { LECONS } from "./lecons";

export function AideDuPoste() {
  return (
    <div className="flex flex-col gap-3 text-[14px] leading-relaxed text-muted">
      {LECONS.map((l) => (
        <Carte key={l.cle} remplissage="sm" role="group" aria-label={l.titre}>
          <h3 className="flex items-center gap-2 text-[15px] font-bold text-fg">
            <span aria-hidden>{l.emoji}</span>
            {l.titre}
          </h3>
          {l.texte.map((t, i) => (
            <Paragraphe key={i} texte={t} className="mt-1.5" />
          ))}
        </Carte>
      ))}
    </div>
  );
}
